package com.devsusana.portfolio.data

import com.devsusana.portfolio.models.Project

/**
 * Local catalog of showcased projects.
 */
object LocalProjectsData {
    val homeTutorPro = Project(
        id = "hometutorpro",
        title = "HomeTutorPro",
        subtitle = "Mobile Productivity for Private In-Home Tutors",
        description = "A production-grade Android application engineered with Clean Architecture and Jetpack Compose, designed to solve scheduling, finance, and student tracking for mobile tutors.",
        longDescription = """
            HomeTutorPro was designed from the ground up as a resilient, real-world productivity system.
            It tackles the friction private tutors face every day: navigating between locations, managing multi-tier pricing,
            logging offline attendance in low-connectivity areas, and sharing class notes.
            Built with strict Clean Architecture (Domain, Data, Presentation), offline-first Room persistence, and supported by a custom multi-agent AI audit suite.
        """.trimIndent(),
        iconPath = "/images/hometutor/ic_app_icon.png",
        bannerPath = "/images/hometutor/feature_graphic.png",
        screenshots = listOf(
            "/images/hometutor/play_store/01_dashboard.jpg",
            "/images/hometutor/play_store/03_sue_ia.jpg",
            "/images/hometutor/play_store/04_widget.jpg",
            "/images/hometutor/play_store/05_alumnos.jpg",
            "/images/hometutor/play_store/06_perfil_gps.jpg",
            "/images/hometutor/play_store/08_finanzas_cobros.jpg",
            "/images/hometutor/play_store/07_horario_vertical.jpg",
            "/images/hometutor/play_store/landscape_01_horario_panoramico.jpg"
        ),
        tags = listOf(
            "Kotlin",
            "Jetpack Compose",
            "Clean Architecture",
            "Coroutines & Flow",
            "Hilt",
            "Room DB",
            "Offline-First",
            "Agentic AI Audit"
        ),
        githubUrl = "https://github.com/DEVSusana/HomeTutorPro",
        playStoreUrl = null,
        isFeatured = true,
        architectureHighlights = listOf(
            "Layered Clean Architecture: Strict separation of concerns across Domain (pure Kotlin), Data, and Presentation with MVVM and UDF.",
            "Offline-First Design: Room database as the single source of truth with background synchronization.",
            "Type-Safe Navigation: Sealed hierarchy for type-safe route destinations across Compose screens.",
            "Agentic AI Verification: Local Gemini-powered audit orchestrator checking architecture rules, KDocs, security, and test skeletons."
        ),
        keyFeatures = listOf(
            "Student Profiles: Complete records with contact info, subjects, hourly rates, and notes.",
            "Dynamic Schedule: Daily and weekly agenda optimized for traveling tutors.",
            "Integrated Maps: Direct navigation to student addresses via Google Maps intents.",
            "Finance & Attendance: Lesson tracking, rates, payment status, and pending balances.",
            "Direct Communication: One-tap shortcuts for WhatsApp messaging and email.",
            "Resource Management: PDF and document organization organized per student."
        )
    )

    val allProjects: List<Project> = listOf(homeTutorPro)
}
